import '../../boot'
import './index.scss'
import { createApp } from 'vue/dist/vue.esm-bundler'
import AppLayoutMixin from '../../app-layout-mixin'
import {  NFormItem, NForm, NCard, NInput, NCheckbox, NSpace } from 'naive-ui'
import EmbedCode from "@/components/embed";


createApp({
    components: {  NFormItem, NForm, NCard, NInput, NCheckbox, NSpace, EmbedCode },
    mixins: [ AppLayoutMixin ],
    data() {
        return {
           string: '',
            trimWhitespaces: true,
            stripHtml: false,
        }
    },
    computed: {

        stringFiltered() {
            let string = this.string;

            if (this.trimWhitespaces) {
                string = string.trim();
            }

            if (this.stripHtml) {
                // string = string.trim();
                string = string.replaceAll(/<\/?[^>]+(>|$)/gi, "")
            }

            return string;
        },

        resultChars() {
            return this.stringFiltered.length;
        },

        resultCharsWaWhiteSpaces() {
            return this.stringFiltered.replace(/\s/g, '') .length;
        },

        resultWords() {
            if (!this.stringFiltered.trim().length) {
                return 0;
            }
            return this.stringFiltered.replace(/-/g, ' ').trim().split(/\s+/g).length;
        },

        resultSentences() {
            if (!this.stringFiltered.trim().length) {
                return 0;
            }
            return this.stringFiltered.split(/[.!?]/).filter(Boolean).length;
        },

    }
}).mount('#app')
